/**
 * =========================================================================================
 *     Copyright © 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *     Feature         :   041-documentation-backend
 *     Description     :   Container component — wires useRunbooks hook into the
 *                         RunbooksPage presentational component.
 *     Constitution    :   v1.12.0
 * =========================================================================================
 */

import React from 'react';
import { RunbooksPage } from './RunbooksPage';
import { useRunbooks } from '../../hooks/useDocumentation';

export const RunbooksContainer: React.FC = () => {
  const { data: runbooks, isLoading, error } = useRunbooks();

  return (
    <RunbooksPage
      runbooks={runbooks}
      isLoading={isLoading}
      error={error ?? null}
    />
  );
};

export default RunbooksContainer;
